import { render } from "./Safeguarding.vue?vue&type=template&id=c4470950&scoped=true"
import script from "./Safeguarding.vue?vue&type=script&lang=js"
export * from "./Safeguarding.vue?vue&type=script&lang=js"

import "./Safeguarding.vue?vue&type=style&index=0&id=c4470950&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c4470950"]])

export default __exports__